module.exports = __webpack_public_path__ + "img/logo-vega-monitoramento.64f72f00.svg";